import { log } from "utils/log"

export function LogPastes() {
  return {
    onPaste: (event, editor, next) => {
      try {
        const types = event.clipboardData.types.slice().sort()
        let length = -1

        types.forEach(type => {
          let data = event.clipboardData.getData(type)

          if (type === "text/plain") {
            length = data.length
          }

          return [type, data]
        })

        const data = {
          location: editor.props.location,
          url: window.location.href,
          lenght_int: length,
          types
        }

        if (types.includes("text/html")) {
          data.html = event.clipboardData.getData("text/html")
        }

        log("paste", data)
      } catch (e) {
        console.error(e)
      }
      return next()
    }
  }
}
